<template>
  <div>
    <v-list three-line>
      <div v-for="item in list" :key="item.id">
        <v-list-item v-ripple :to="'/detail/' + encrypt(item.id)">
          <font-avatar :name="item.name"></font-avatar>

          <v-list-item-content>
            <v-list-item-title
              class="d-flex align-center justify-space-between"
            >
              <span>
                {{ item.name }}
                <level-chip :level="item.level"></level-chip>
              </span>
              <span class="text--disabled caption">
                {{ item.create_time }}
              </span>
            </v-list-item-title>
            <v-list-item-subtitle>{{ item.info }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
      </div>
      <v-list-item class="d-flex justify-center">
        <v-list-item-action>
          <v-btn
            :disabled="btnActive"
            @click="load()"
            min-width="300"
            text
            color="primray"
          >
            {{ btn }}</v-btn
          >
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
// 弃用
import EventBus from "@/tools/event-bus";
import list from "@/networker/list";
import aes from "@/tools/aes";
import LevelChip from "@/components/common/LevelChip/levelChip";
import FontAvatar from "@/components/common/FontAvatar/fontAvatar";
export default {
  components: {
    LevelChip,
    FontAvatar
  },
  data() {
    return {
      page: 1,
      count: 10,
      error: false,
      errorMessage: "",
      btn: "加载更多",
      btnActive: false,
      list: []
    };
  },
  mounted() {
    EventBus.$on("listDelete", id => {
      this.list.forEach((val, key) => {
        if (val.id === id) {
          this.list.splice(key, 1);
        }
      });
    });
  },
  computed: {},
  methods: {
    encrypt: function(text) {
      return aes.encrypt(text);
    },
    load: function() {
      //检测玩家是否登录

      if (!this.$store.state.user.islogin) {
        this.$emit("snackbar", {
          text: "请登录",
          color: "blue"
        });

        return;
      }
      this.btn = "加载中";
      this.btnActive = true;
      list
        .private(this.count, this.page)
        .then(res => {
          this.btn = "加载更多";
          this.btnActive = false;
          if (res.data.error !== 200) {
            //获取失败
            this.error = true;
            this.errorMessage = res.data.message;
          } else {
            let list = res.data.data.list.data;
            if (list.length === 0) {
              this.btn = "木有了，zZZ";
            } else {
              this.page++;
              this.list.push(...list);
            }
          }
        })
        .catch(() => {
          this.btn = "加载更多";
          this.btnActive = false;
        });
    }
  },
  created() {
    this.load();
  }
};
</script>

<style></style>
